import { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Grid, Input, Message, TextArea } from 'semantic-ui-react';
import {
    Icon,
    Step,
  } from 'semantic-ui-react';
import { SingleRangeSlider } from 'neo-react-semantic-ui-range'
import 'neo-react-semantic-ui-range/dist/styles.min.css'
import './CreateProjectWizard.scss';
import Member from '../../../../structures/member';
import Place from '../../../../structures/place';
import HistoryObject from '../../../../structures/historyObject';
import Project from '../../../../structures/project';
import api, { TitleAndTextResponse } from '../../../../utils/api';
import MembersStep from './components/MembersStep/MembersStep';
import PlacesStep from './components/PlacesStep/PlacesStep';
import ObjectsStep from './components/ObjectsStep/ObjectsStep';
import ExamplesGenerator from '../../../../shared/ExamplesGenerator/ExamplesGenerator';

export enum StepType {
    Start,
    Author,
    Name,
    Style,
    Description,
    Members,
    Places,
    Objects,
    End,
}

interface CreateProjectWizardProps {
    viewWelcomStep?:boolean
    onFinish:(project:Project)=>void
}

function CreateProjectWizard({viewWelcomStep = false, onFinish}:CreateProjectWizardProps) {
    const [step, setStep] = useState<StepType>(viewWelcomStep ? StepType.Start : StepType.Author);
    const [author, setAuthor] = useState('');
    const [name, setName] = useState('');
    const [styleTypeForm, setStyleTypeForm] = useState('Рассказ');
    const [styleType, setStyleType] = useState<string[]>(['Любовная история', 'Приключения', 'Фантастика']);
    const [comedy, setComedy] = useState<number>(80);
    const [tragedyc, setTragedyc] = useState<number>(30);
    const [drame, setDrame] = useState<number>(60);
    const [scary, setScary] = useState<number>(20);
    const [artistry, setArtistry] = useState<number>(50);
    const [description, setDescription] = useState('');
    const [isDescriptionError, setIsDescriptionError] = useState(false);
    const [members, setMembers] = useState<Member[]>([]);
    const [places, setPlaces] = useState<Place[]>([]);
    const [objects, setObjects] = useState<HistoryObject[]>([]);
    useEffect(()=>{
        api.getUserInfo().then(userInfo => {
            setAuthor(`${userInfo.firstName} ${userInfo.lastName}`);
        });
    }, []);
    useEffect(()=>{
        if(step === StepType.End){
            api.createProject(author, name, styleTypeForm, styleType, comedy, tragedyc, drame, scary, artistry, description, members, places, objects).then(onFinish);
        }
    }, [step]);
    return <div className='create-project-wizard'>
        {(step !== StepType.Start && step !== StepType.Author) && <Step.Group>
            <Step active={step === StepType.Name} completed={step > StepType.Name} onClick={step > StepType.Name ? () => setStep(StepType.Name) : undefined}>
                <Icon name='idea' />
                <Step.Content>
                    <Step.Title>Идея</Step.Title>
                    <Step.Description>{step > StepType.Name ? name : 'Что пишем?'}</Step.Description>
                </Step.Content>
            </Step>

            <Step active={step === StepType.Style} completed={step > StepType.Style} disabled={step < StepType.Style} onClick={step > StepType.Style ? () => setStep(StepType.Style) : undefined}>
                <Icon name='edit outline' />
                <Step.Content>
                    <Step.Title>Жанр</Step.Title>
                    <Step.Description>{step > StepType.Style ? `${styleTypeForm} (${styleType.join(', ')})` : 'В каком стиле?'}</Step.Description>
                </Step.Content>
            </Step>
            <Step active={step === StepType.Description} completed={step > StepType.Description} disabled={step < StepType.Description}  onClick={step > StepType.Description ? () => setStep(StepType.Description) : undefined}>
                <Icon name='align justify' />
                <Step.Content>
                    <Step.Title>Описание</Step.Title>
                    <Step.Description>{step > StepType.Description ? description : 'Описание истории'}</Step.Description>
                </Step.Content>
            </Step>

            <Step active={step === StepType.Members} completed={step > StepType.Members} disabled={step < StepType.Members}>
                <Icon name='users' />
                <Step.Content>
                    <Step.Title>Персонажи</Step.Title>
                    <Step.Description>{step > StepType.Members ? members.map(x=>x.name).join(', ') : 'Кто герои?'}</Step.Description>
                </Step.Content>
            </Step>
            <Step active={step === StepType.Places} completed={step > StepType.Places} disabled={step < StepType.Places}>
                <Icon name='point' />
                <Step.Content>
                    <Step.Title>Места</Step.Title>
                    <Step.Description>{step > StepType.Places ? places.map(x=>x.name).join(', ') : 'Где происходит?'}</Step.Description>
                </Step.Content>
            </Step>
            <Step active={step === StepType.Objects} completed={step > StepType.Objects} disabled={step < StepType.Objects}>
                <Icon name='archive' />
                <Step.Content>
                    <Step.Title>Предметы</Step.Title>
                    <Step.Description>Сюжетные вещи</Step.Description>
                </Step.Content>
            </Step>
        </Step.Group>}
        <div className='step-content'>
            {(()=>{
                switch(step) {
                    case StepType.Start: return <div className='start'>
                        <h1>Добро пожаловать в Story maker!</h1>
                        <p>Станьте автором вашей истории! Пишите рассказ о себе или своих друзьях, а ИИ помощник поможет с текстом и иллюстрациями.</p>
                        <Button fluid primary size='huge' icon onClick={() => setStep(StepType.Author)}><Icon name='star outline'/> Начать</Button>
                    </div>;
                    case StepType.Author: return <div className='start'>
                        <Input value={author} fluid placeholder='Автор' size='huge' onChange={(e) => setAuthor(e.target.value)} />
                        <p>Укажите имя или псевдоним автора.</p>
                        <Button fluid primary size='huge' onClick={() => setStep(StepType.Name)}>Далее к названию</Button>
                    </div>;
                    case StepType.Name: return <div className='name'>
                        <Input value={name} fluid placeholder='Название истории' size='huge' onChange={(e) => setName(e.target.value)} />
                        <ExamplesGenerator 
                            popupDescription='Придумать примеры названий историй'
                            target={name}
                            context={author}
                            apiMethod={api.getProjectNameExamplesByUserName} 
                            onSelect={setName} 
                        />
                        <Button disabled={name === ''} fluid primary size='huge' icon onClick={() => setStep(StepType.Style)}>Далее к выбору жанра</Button>
                    </div>;
                    case StepType.Style: return <div>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    {['Роман',
                                    'Рассказ',
                                    'Очерк', 
                                    'Повесть',
                                    'Сценарий',
                                    'Статья',
                                    'Мемуары',
                                    'Скетч',
                                    ].map(styleTypeOption => <div>
                                        <Form.Radio
                                        
                                        label={styleTypeOption}
                                        value={styleTypeOption}
                                        checked={styleTypeForm === styleTypeOption}
                                        onChange={(e, { value })=>{setStyleTypeForm(value! as string)}}
                                        />
                                    </div>)}
                                </Grid.Column>
                                <Grid.Column width={3}>
                                    {['Любовная история',
                                    'Детектив',
                                    'Мистика',
                                    'Приключения',
                                    'Фантастика',
                                    'Фэнтези',
                                    'Боевик',
                                    'Юмор'].map(styleTypeOption => <div>
                                        <Checkbox
                                            label={styleTypeOption}
                                            onChange={(e, data) => {
                                                if(data.checked){
                                                    setStyleType([...styleType, styleTypeOption]);
                                                }else{
                                                    setStyleType(styleType.filter(x=>x!==styleTypeOption));
                                                }
                                            }}
                                            checked={styleType.includes(styleTypeOption)}
                                        />
                                    </div>)}
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <Grid className='category-settings'>
                                        <Grid.Row>
                                            <Grid.Column width={3}>Комедия</Grid.Column>
                                            <Grid.Column width={13}><SingleRangeSlider
                                                value={comedy}
                                                defaultMinValue={0}
                                                defaultMaxValue={100}
                                                step={0.5}
                                                color='yellow'
                                                onChange={setComedy}
                                            /></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={3}>Трагедия</Grid.Column>
                                            <Grid.Column width={13}><SingleRangeSlider
                                                value={tragedyc}
                                                defaultMinValue={0}
                                                defaultMaxValue={100}
                                                step={0.5}
                                                color='teal'
                                                onChange={setTragedyc}
                                            /></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={3}>Драма</Grid.Column>
                                            <Grid.Column width={13}><SingleRangeSlider
                                                value={drame}
                                                defaultMinValue={0}
                                                defaultMaxValue={100}
                                                step={0.5}
                                                color='blue'
                                                onChange={setDrame}
                                            /></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={3}>Ужасы</Grid.Column>
                                            <Grid.Column width={13}><SingleRangeSlider
                                                value={scary}
                                                defaultMinValue={0}
                                                defaultMaxValue={100}
                                                step={0.5}
                                                color='pink'
                                                onChange={setScary}
                                            /></Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className='artistry-range'>
                                <Grid.Column width={2}>Компактно</Grid.Column>
                                <Grid.Column width={12}><SingleRangeSlider
                                    value={artistry}
                                    defaultMinValue={0}
                                    defaultMaxValue={100}
                                    step={0.5}
                                    color='olive'
                                    onChange={setArtistry}
                                /></Grid.Column>
                                <Grid.Column width={2}>Многословно</Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Button fluid primary size='huge' icon onClick={() => setStep(StepType.Description)}>Далее к описанию</Button>
                    </div>;
                    case StepType.Description: return <div className='description'>
                        <Message>Кратко опишите сюжет истории. Расскажите про завязку сюжета и как она разрешается.</Message>
                        <Form>
                            <Form.Field
                            control={TextArea}
                            placeholder='Кратко опишите сюжет истории: когда и где она происходит, завязку, развитие, завершение...'
                            value={description}
                            onChange={(e:any) => setDescription(e.target.value)}
                            error={isDescriptionError}
                            onFocus={() => setIsDescriptionError(false)}
                            />
                            <ExamplesGenerator<TitleAndTextResponse> 
                                popupDescription='Придумать примеры сюжета истории'
                                target={description}
                                context={name} 
                                apiMethod={api.getProjectDescriptionExamplesByName} 
                                onSelect={x => setDescription(x.text)} 
                                toTextDisplay={x=>x.title}
                                toPopupDisplay={x=>x.text}
                            />
                            <Button disabled={description === ''} fluid primary size='huge' icon onClick={() => setStep(StepType.Members)}>Создать персонажей</Button>
                        </Form>
                    </div>;
                    case StepType.Members: return <MembersStep description={description} setStep={setStep} members={members} setMembers={setMembers} />;
                    case StepType.Places: return <PlacesStep description={description} setStep={setStep} places={places} setPlaces={setPlaces} />;
                    case StepType.Objects: return <ObjectsStep description={description} setStep={setStep} objects={objects} setObjects={setObjects} />;
                    default: return <div>Unknown step...</div>;
                }
            })()}
        </div>
    </div>;
}
  
export default CreateProjectWizard;
  